import { forwardRef } from "react"

type IndicatorOwnProps = Readonly<{
  checked?: boolean
}>

export type IndicatorProps = IndicatorOwnProps & React.ComponentPropsWithRef<"span">

const Indicator: React.FC<IndicatorProps> = forwardRef(({ checked, ...indicatorProps }: IndicatorProps, forwardedRef) =>
  checked ? <span ref={forwardedRef} data-state="checked" {...indicatorProps} /> : null
)

Indicator.displayName = `RadioGroupIndicator`

export { Indicator }
